export default __webpack_public_path__ + "static/media/rhombus.ae302047.svg";